import mixinActivities from '@/mixins/activitiesModule';
import mixinOrganizations from '@/mixins/organizationsModule';
import mixinVacancies from '@/mixins/vacanciesModule';
import mixinPfdod from '@/mixins/isPfdodCheck';
import mixinIntalent from '@/mixins/isIntalentCheck';
import mixinModules from '@/mixins/isModules';
import { format } from 'date-fns';

const mixin = {
  mixins: [
    mixinActivities,
    mixinOrganizations,
    mixinVacancies,
    mixinPfdod,
    mixinIntalent,
    mixinModules,
  ],
  computed: {
    mainNav() {
      const prepare = (text, name, section, subsection, query) => ({
        text,
        to: {
          name,
          params: {
            section,
            subsection,
          },
          query,
        },
      });
      const {
        isActivities,
        isModules,
        navRouteName,
        $store: { state },
      } = this;
      const {
        sections = [],
        activitySections = [],
        modulesSections = [],
        municipality,
        route,
      } = state;
      let query = municipality ? { municipality } : {};

      if (route.query.date) {
        query = {
          ...query,
          date: format(new Date(route.query.date), 'YYYY-MM-DD'),
        };
      }

      const result = (
        isActivities ? activitySections : isModules ? modulesSections : sections
      ).map(({ name, code, children }) => {
        const result = prepare(name, navRouteName, code, null, query);
        if (children) {
          result.children = children.map((child) =>
            prepare(child.name, navRouteName, code, child.code, query)
          );
        }
        return result;
      });

      return result;
    },

    headerMenu() {
      // const {
      //   hasOrganizationsModule,
      //   isPfdodModule,
      //   isIntalentModule,
      //   hasVacanciesModule,
      //   hasActivitiesModule,
      // } = this;

      const isActiveModule = (moduleName) =>
        this.$store.state.apiModules.some((el) => el.alias === moduleName);

      const result = [
        ...require('./menu.programms.js').default,
        ...require('./menu.activities.js').default,
        ...((this.$store.getters.hasApiModuleVacancies ||
          this.$store.getters.hasApiModuleVacanciesOrders) &&
          require('./menu.vacancies.js').default),
        ...require('./menu.professions.js').default,
        ...require('./menu.competences.js').default,
        ...require('./menu.organizations.js').default,
        ...require('./menu.modules.js').default,
      ];

      // if (
      //   this.$store.getters.hasApiModuleVacancies ||
      //   this.$store.getters.hasApiModuleVacanciesOrders
      // ) {
      //   result.push(...require('./menu.vacancies.js').default);
      // }
      // if (hasOrganizationsModule)
      //   result.push(...require('./menu.organizations.js').default);
      // if (hasVacanciesModule)
      //   result.push(...require('./menu.vacancies.js').default);
      // result.push(...require('./menu.activities.js').default);
      // if (isIntalentModule)
      //   result.push(...require('./menu.intalent.js').default);
      // if (isPfdodModule) result.push(...require('./menu.pf-dod.js').default);
      return result;
    },

    askQuestion() {
      const result = [];
      if (this.isPfdodModule)
        result.push(...require('./menu.ask-pfdod.js').default);
      return result;
    },

    mobileMenu() {
      const { mainNav, headerMenu, askQuestion, isPfdodModule } = this;
      if (!isPfdodModule) {
        return [mainNav, headerMenu];
      }
      return [mainNav, headerMenu, askQuestion];
    },
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/pages/mixin-nav.js